"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobMessageResponse = exports.JobMessageRequest = exports.JobResult = exports.JobRequestType = exports.StartPackageUpdateResponse = exports.StartPackageUpdateRequest = exports.StartFetchResponse = exports.StartFetchRequest = exports.StartPackageResponse = exports.StartPackageRequest = exports.DataStopAcknowledge = exports.DataStop = exports.DataAcknowledge = exports.DataSend = exports.StartProxyFetchResponse = exports.StartProxyFetchRequest = exports.ProxyFetchResponseType = exports.ProxyFetchRequestType = exports.SocketProxyFetchEvent = exports.OpenFetchProxyChannelResponse = exports.OpenFetchProxyChannelRequest = exports.UploadStopResponse = exports.UploadStopRequest = exports.UploadDataResponse = exports.UploadDataRequest = exports.StartUploadResponse = exports.StartUploadRequest = exports.UploadResponseType = exports.UploadRequestType = exports.SetStreamActiveBatchesResponse = exports.SetStreamActiveBatchesRequest = exports.PackageStreamsResponse = exports.PackageStreamsRequest = exports.PackageSinkStateResponse = exports.PackageSinkStateRequest = exports.ErrorResponse = exports.SocketResponseType = exports.SocketError = exports.SocketEvent = void 0;
var SocketEvent;
(function (SocketEvent) {
    SocketEvent["READY"] = "ready";
    SocketEvent["OPEN_FETCH_CHANNEL"] = "openFetchChannel";
    SocketEvent["START_DATA_UPLOAD"] = "startDataUpload";
    SocketEvent["SET_STREAM_ACTIVE_BATCHES"] = "setStreamActiveBatchesRequest";
    SocketEvent["SCHEMA_INFO_REQUEST"] = "schemaInfoRequest";
    SocketEvent["PACKAGE_VERSION_SINK_STATE_REQUEST"] = "packageVersionSinkStateRequest";
    SocketEvent["START_PACKAGE_UPDATE"] = "startPackageUpdate";
    SocketEvent["START_PACKAGE"] = "startPackage";
    SocketEvent["START_FETCH"] = "startFetch";
})(SocketEvent = exports.SocketEvent || (exports.SocketEvent = {}));
var SocketError;
(function (SocketError) {
    SocketError["NOT_AUTHORIZED"] = "notAuthorized";
    SocketError["NOT_FOUND"] = "notFound";
    SocketError["NOT_VALID"] = "notValid";
    SocketError["STREAM_LOCKED"] = "streamLocked";
    SocketError["SERVER_ERROR"] = "serverError";
    SocketError["NOT_STARTED"] = "streamProcessNotStarted";
})(SocketError = exports.SocketError || (exports.SocketError = {}));
var SocketResponseType;
(function (SocketResponseType) {
    SocketResponseType["ERROR"] = "error";
    SocketResponseType["SCHEMA_INFO_RESPONSE"] = "schemaInfoResponse";
    SocketResponseType["START_DATA_UPLOAD_RESPONSE"] = "startDataUploadResponse";
    SocketResponseType["SET_STREAM_ACTIVE_BATCHES"] = "setStreamActiveBatchesResponse";
    SocketResponseType["OPEN_FETCH_CHANNEL_RESPONSE"] = "openFetchChannelResponse";
    SocketResponseType["PACKAGE_VERSION_SINK_STATE_RESPONSE"] = "packageVersionSinkStateResponse";
    SocketResponseType["START_PACKAGE_UPDATE_RESPONSE"] = "startPackageUpdateResponse";
    SocketResponseType["START_PACKAGE_RESPONSE"] = "startPackageResponse";
})(SocketResponseType = exports.SocketResponseType || (exports.SocketResponseType = {}));
class ErrorResponse {
    constructor(message, errorType) {
        this.message = message;
        this.errorType = errorType;
        this.responseType = SocketResponseType.ERROR;
    }
}
exports.ErrorResponse = ErrorResponse;
class PackageSinkStateRequest {
    constructor(identifier) {
        this.identifier = identifier;
        this.requestType = SocketEvent.PACKAGE_VERSION_SINK_STATE_REQUEST;
    }
}
exports.PackageSinkStateRequest = PackageSinkStateRequest;
class PackageSinkStateResponse {
    constructor(identifier, state) {
        this.identifier = identifier;
        this.state = state;
        this.responseType = SocketResponseType.PACKAGE_VERSION_SINK_STATE_RESPONSE;
    }
}
exports.PackageSinkStateResponse = PackageSinkStateResponse;
class PackageStreamsRequest {
    constructor(identifier) {
        this.identifier = identifier;
        this.requestType = SocketEvent.SCHEMA_INFO_REQUEST;
    }
}
exports.PackageStreamsRequest = PackageStreamsRequest;
class PackageStreamsResponse {
    constructor(identifier, batchesBySchema) {
        this.identifier = identifier;
        this.batchesBySchema = batchesBySchema;
        this.responseType = SocketResponseType.SCHEMA_INFO_RESPONSE;
    }
}
exports.PackageStreamsResponse = PackageStreamsResponse;
class SetStreamActiveBatchesRequest {
    constructor(batchIdentifiers) {
        this.batchIdentifiers = batchIdentifiers;
        this.requestType = SocketEvent.SET_STREAM_ACTIVE_BATCHES;
    }
}
exports.SetStreamActiveBatchesRequest = SetStreamActiveBatchesRequest;
class SetStreamActiveBatchesResponse {
    constructor(batchIdentifiers) {
        this.batchIdentifiers = batchIdentifiers;
        this.responseType = SocketResponseType.SET_STREAM_ACTIVE_BATCHES;
    }
}
exports.SetStreamActiveBatchesResponse = SetStreamActiveBatchesResponse;
var UploadRequestType;
(function (UploadRequestType) {
    UploadRequestType["UPLOAD_DATA"] = "uploadData";
    UploadRequestType["UPLOAD_STOP"] = "uploadStop";
})(UploadRequestType = exports.UploadRequestType || (exports.UploadRequestType = {}));
var UploadResponseType;
(function (UploadResponseType) {
    UploadResponseType["UPLOAD_RESPONSE"] = "uploadResponse";
    UploadResponseType["UPLOAD_STOP_RESPONSE"] = "uploadStopResponse";
})(UploadResponseType = exports.UploadResponseType || (exports.UploadResponseType = {}));
class StartUploadRequest {
    constructor(schemaStreamIdentifier, newBatch, updateMethod) {
        this.schemaStreamIdentifier = schemaStreamIdentifier;
        this.newBatch = newBatch;
        this.updateMethod = updateMethod;
        this.requestType = SocketEvent.START_DATA_UPLOAD;
    }
}
exports.StartUploadRequest = StartUploadRequest;
class StartUploadResponse {
    constructor(channelName, batchIdentifier) {
        this.channelName = channelName;
        this.batchIdentifier = batchIdentifier;
        this.responseType = SocketResponseType.START_DATA_UPLOAD_RESPONSE;
    }
}
exports.StartUploadResponse = StartUploadResponse;
class UploadDataRequest {
    constructor(records) {
        this.records = records;
        this.requestType = UploadRequestType.UPLOAD_DATA;
    }
}
exports.UploadDataRequest = UploadDataRequest;
class UploadDataResponse {
    constructor() {
        this.responseType = UploadResponseType.UPLOAD_RESPONSE;
    }
}
exports.UploadDataResponse = UploadDataResponse;
class UploadStopRequest {
    constructor() {
        this.requestType = UploadRequestType.UPLOAD_STOP;
    }
}
exports.UploadStopRequest = UploadStopRequest;
class UploadStopResponse {
    constructor() {
        this.responseType = UploadResponseType.UPLOAD_STOP_RESPONSE;
    }
}
exports.UploadStopResponse = UploadStopResponse;
class OpenFetchProxyChannelRequest {
    constructor(batchIdentifier) {
        this.batchIdentifier = batchIdentifier;
        this.requestType = SocketEvent.OPEN_FETCH_CHANNEL;
    }
}
exports.OpenFetchProxyChannelRequest = OpenFetchProxyChannelRequest;
class OpenFetchProxyChannelResponse {
    constructor(channelName, batchIdentifier) {
        this.channelName = channelName;
        this.batchIdentifier = batchIdentifier;
        this.responseType = SocketResponseType.OPEN_FETCH_CHANNEL_RESPONSE;
    }
}
exports.OpenFetchProxyChannelResponse = OpenFetchProxyChannelResponse;
var SocketProxyFetchEvent;
(function (SocketProxyFetchEvent) {
    SocketProxyFetchEvent["FETCH_DATA_ACKNOWLEDGE"] = "fetchDataAcknowledge";
    SocketProxyFetchEvent["FETCH_DATA_END"] = "fetchDataEnd";
})(SocketProxyFetchEvent = exports.SocketProxyFetchEvent || (exports.SocketProxyFetchEvent = {}));
var ProxyFetchRequestType;
(function (ProxyFetchRequestType) {
    ProxyFetchRequestType["START"] = "fetchDataStart";
    ProxyFetchRequestType["DATA"] = "data";
    ProxyFetchRequestType["STOP"] = "fetchDataStop";
})(ProxyFetchRequestType = exports.ProxyFetchRequestType || (exports.ProxyFetchRequestType = {}));
var ProxyFetchResponseType;
(function (ProxyFetchResponseType) {
    ProxyFetchResponseType["START_ACKNOWLEDGE"] = "startAcknowledge";
    ProxyFetchResponseType["DATA_ACKNOWLEDGE"] = "dataAcknowledge";
    ProxyFetchResponseType["STOP_ACKNOWLEDGE"] = "fetchDataStopAcknowledge";
})(ProxyFetchResponseType = exports.ProxyFetchResponseType || (exports.ProxyFetchResponseType = {}));
class StartProxyFetchRequest {
    constructor(offset) {
        this.offset = offset;
        this.requestType = ProxyFetchRequestType.START;
    }
}
exports.StartProxyFetchRequest = StartProxyFetchRequest;
class StartProxyFetchResponse {
    constructor() {
        this.responseType = ProxyFetchResponseType.START_ACKNOWLEDGE;
    }
}
exports.StartProxyFetchResponse = StartProxyFetchResponse;
class DataSend {
    constructor(records) {
        this.records = records;
        this.requestType = ProxyFetchRequestType.DATA;
    }
}
exports.DataSend = DataSend;
class DataAcknowledge {
    constructor() {
        this.responseType = ProxyFetchResponseType.DATA_ACKNOWLEDGE;
    }
}
exports.DataAcknowledge = DataAcknowledge;
class DataStop {
    constructor() {
        this.requestType = ProxyFetchRequestType.STOP;
    }
}
exports.DataStop = DataStop;
class DataStopAcknowledge {
    constructor() {
        this.responseType = ProxyFetchResponseType.STOP_ACKNOWLEDGE;
    }
}
exports.DataStopAcknowledge = DataStopAcknowledge;
class StartPackageRequest {
    constructor(catalogSlug, packageSlug, packageTitle, packageDescription, defaults) {
        this.requestType = SocketEvent.START_PACKAGE;
        this.catalogSlug = catalogSlug;
        this.packageSlug = packageSlug;
        this.packageTitle = packageTitle;
        this.packageDescription = packageDescription;
        this.defaults = defaults;
    }
}
exports.StartPackageRequest = StartPackageRequest;
class StartPackageResponse {
    constructor(channelName) {
        this.responseType = SocketResponseType.START_PACKAGE_RESPONSE;
        this.channelName = channelName;
    }
}
exports.StartPackageResponse = StartPackageResponse;
class StartFetchRequest {
    constructor(catalogSlug, packageSlug, sinkType, defaults) {
        this.requestType = SocketEvent.START_FETCH;
        this.catalogSlug = catalogSlug;
        this.packageSlug = packageSlug;
        this.sinkType = sinkType;
        this.defaults = defaults;
    }
}
exports.StartFetchRequest = StartFetchRequest;
class StartFetchResponse {
    constructor(channelName) {
        this.responseType = SocketResponseType.START_PACKAGE_RESPONSE;
        this.channelName = channelName;
    }
}
exports.StartFetchResponse = StartFetchResponse;
class StartPackageUpdateRequest {
    constructor(packageIdentifier, defaults) {
        this.packageIdentifier = packageIdentifier;
        this.defaults = defaults;
        this.requestType = SocketEvent.START_PACKAGE_UPDATE;
    }
}
exports.StartPackageUpdateRequest = StartPackageUpdateRequest;
class StartPackageUpdateResponse {
    constructor(channelName) {
        this.responseType = SocketResponseType.START_PACKAGE_UPDATE_RESPONSE;
        this.channelName = channelName;
    }
}
exports.StartPackageUpdateResponse = StartPackageUpdateResponse;
var JobRequestType;
(function (JobRequestType) {
    JobRequestType["START_JOB"] = "startJob";
    JobRequestType["PRINT"] = "print";
    JobRequestType["PROMPT"] = "prompt";
    JobRequestType["START_TASK"] = "startTask";
    JobRequestType["TASK_UPDATE"] = "taskUpdate";
    JobRequestType["END_TASK"] = "endTask";
    JobRequestType["SET_CURRENT_STEP"] = "setCurrentStep";
    JobRequestType["SET_STEPS"] = "setSteps";
    JobRequestType["EXIT"] = "exit";
    JobRequestType["ERROR"] = "error";
})(JobRequestType = exports.JobRequestType || (exports.JobRequestType = {}));
class JobResult {
}
exports.JobResult = JobResult;
class JobMessageRequest {
    constructor(requestType) {
        this.requestType = requestType;
    }
}
exports.JobMessageRequest = JobMessageRequest;
class JobMessageResponse {
    constructor(responseType) {
        this.responseType = responseType;
    }
}
exports.JobMessageResponse = JobMessageResponse;
//# sourceMappingURL=SocketUtil.js.map